// LoadingScreen.jsx
import React from 'react';
import { Box, Typography } from '@mui/material';
import logo from '../assests/images/logo.png'; // Make sure the path is correct

export default function LoadingScreen() {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column',
        backgroundColor: '#fceade', // Optional background color
      }}
    >
      <img src={logo} alt="Logo" style={{ width: '150px', marginBottom: '20px' }} />
      
    </Box>
  );
}
